import { useQuery, useQueryClient } from '@tanstack/react-query';
import type { PlatformBitriseTokenRequest, PlatformExpoTokenRequest } from '@hangar/shared';
import { api } from './client';
import { PlatformProvider, PlatformProviders } from './schemasPlatformProviders';

/* ---------- Malible's Expo and Bitrise tokens (SPEC decision 19, platform operators only) ---------- */

export const platformProvidersKey = ['platform', 'providers'] as const;

export const getPlatformProviders = () => api('GET', '/platform/providers', { schema: PlatformProviders });
/** The body is a secret: sent once, never kept in the cache or shown again. */
export const setPlatformExpoToken = (body: PlatformExpoTokenRequest) => api('PUT', '/platform/providers/expo', { schema: PlatformProvider, body });
export const setPlatformBitriseToken = (body: PlatformBitriseTokenRequest) => api('PUT', '/platform/providers/bitrise', { schema: PlatformProvider, body });

export const usePlatformProviders = (enabled: boolean) => useQuery({ queryKey: platformProvidersKey, queryFn: getPlatformProviders, enabled });

/**
 * Puts a provider the API answered into the cached page, then refetches it. The PUT itself is a plain call, not a
 * react-query mutation, so the token never sits in the mutation cache.
 */
export function usePutPlatformProvider() {
  const qc = useQueryClient();
  return (p: PlatformProvider) => {
    qc.setQueryData<PlatformProviders>(platformProvidersKey, (old) => (old ? { ...old, [p.provider]: p } : old));
    void qc.invalidateQueries({ queryKey: platformProvidersKey });
  };
}
